import { render, staticRenderFns } from "./FormSubmittablePeople.vue?vue&type=template&id=5143fd62&"
import script from "./FormSubmittablePeople.vue?vue&type=script&lang=js&"
export * from "./FormSubmittablePeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports